






























import { i18n } from "@/plugins/i18n";

export default {
  name: "CardDisplayImage",
  props: {
    src: {
      default: null
    },
    title: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    ratio: {
      type: Number,
      default: 75
    }
  },
  data() {
    return {
      isShown: false,
      VUE_APP_BACKEND_URI: process.env.VUE_APP_BACKEND_URI
    };
  },
  methods: {
    click(event) {
      this.$emit("click", event);
    }
  }
};
